export interface IPagination {
  page: number
  limit: number
  hasMore: boolean
}


export const getInitPagination = (): IPagination => ({ page: 1, limit: 50, hasMore: false })
